export default __webpack_public_path__ + "static/media/jupi5.16d4a922.png";